

































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";
import iwTooltip from "@/shared/components/Tooltip.vue";

export default Vue.extend({
    name: "ClassifiedEditHintTooltip",
    components: {
        iwTooltip: iwTooltip,
    },
    props: {
        tooltipI18nKey: {
            type: String,
            required: true,
        },
        ariaLabelFieldI18nKey: {
            type: String,
            required: true,
        },
    },
    data: function () {
        return {
            uniqueId: uuidv4() as string,
        };
    },
    computed: {
        targetElementId: function (): string {
            return `classified-edit-hint-${this.uniqueId}`;
        },
        ariaLabelText: function (): string {
            return `${this.$t("more_info_about")} ${this.$t(this.ariaLabelFieldI18nKey)}`;
        },
    },
});
